import { IconRefresh, IconUpload, Link } from 'braid-design-system';
import queryString from 'query-string';
import { useSelector } from 'react-redux';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import Routes from 'src/config/routes';
import { ListingStatus } from 'src/generated/graphql';
import type { StoreProps } from 'src/store';
import type { ClientListingForListingsTab } from 'src/types/graphql-derived';
import { createPostListingUrl } from 'src/utils';

import Action from './Action';

interface PostActionLinkProps {
  listing: ClientListingForListingsTab;
  setLoadingRedirect: () => void;
}

export const PostActionLink = ({
  listing,
  setLoadingRedirect,
}: PostActionLinkProps) => {
  const hasPaid = useSelector((store: StoreProps) => store.account.paid);

  const isDraft = listing.status === ListingStatus.Draft;

  const postLabel = isDraft ? 'Post' : 'Repost';
  const postIcon = isDraft ? IconUpload : IconRefresh;

  const postAction = (
    <Action Icon={postIcon} action={postLabel} onClick={setLoadingRedirect} />
  );

  // If a package has been purchased, redirect to CASBA to post listing
  if (hasPaid) {
    return (
      <ExternalLink
        destination={createPostListingUrl(listing.clientId, listing.id)}
      >
        {postAction}
      </ExternalLink>
    );
  }

  // If no package has been purchased, redirect to the packages page
  return (
    <Link
      href={queryString.stringifyUrl({
        url: Routes.PACKAGES,
        query: { listingId: listing.id },
      })}
    >
      {postAction}
    </Link>
  );
};
